import { Link } from "react-router-dom";
import LegalFooter from "@/components/LegalFooter";

function LegalLayout({ title, updated = "21 Août 2026", children }) {
  return (
    <div className="min-h-screen bg-background">
      <header className="border-b bg-background/90">
        <div className="max-w-5xl mx-auto px-4 py-5 flex items-center justify-between gap-4">
          <Link
            to="/"
            className="flex items-center gap-2 font-head font-extrabold text-xl"
          >
            <span className="w-9 h-9 rounded-xl bg-primary text-primary-foreground grid place-items-center arabic">
              ح
            </span>
            Harf
          </Link>
          <Link to="/" className="text-sm text-primary hover:underline">
            Retour à Harf
          </Link>
        </div>
      </header>
      <main className="max-w-4xl mx-auto px-4 py-10">
        <div className="prose prose-slate dark:prose-invert max-w-none">
          <h1>{title}</h1>
          <p className="text-sm opacity-70">Dernière mise à jour : {updated}</p>
          {children}
        </div>
      </main>
      <LegalFooter />
    </div>
  );
}

export function LegalMentions() {
  return (
    <LegalLayout title="Mentions légales">
      <h2>Éditeur du site</h2>
      <p>Le site Harf est édité par :</p>
      <ul>
        <li>
          <strong>Raison sociale :</strong> SALERNO THEO (Entrepreneur
          individuel)
        </li>
        <li>
          <strong>Forme juridique :</strong> Micro-entreprise
        </li>
        <li>
          <strong>Adresse du siège :</strong> 2 rue Trebois, 92300
          Levallois-Perret
        </li>
        <li>
          <strong>SIREN :</strong> 928 276 427
        </li>
        <li>
          <strong>Numéro de TVA intracommunautaire :</strong> TVA non
          applicable, art. 293 B du CGI
        </li>
        <li>
          <strong>Email de contact :</strong> theo.salerno34@gmail.com
        </li>
        <li>
          <strong>Directeur de la publication :</strong> Théo Salerno
        </li>
      </ul>
      <h2>Hébergement</h2>
      <ul>
        <li>
          <strong>Hébergeur :</strong> Replit, Inc.
        </li>
        <li>
          <strong>Adresse :</strong> 2261 Market Street #5104, San Francisco, CA
          94114, États-Unis
        </li>
        <li>
          <strong>Contact :</strong> contact@replit.com / site web : replit.com
        </li>
      </ul>
      <h2>Propriété intellectuelle</h2>
      <p>
        La marque Harf, les éléments graphiques, le code, les contenus
        pédagogiques et la structure du site sont protégés par les règles
        applicables de propriété intellectuelle. Toute reproduction ou
        réutilisation non autorisée est interdite.
      </p>
      <h2 id="contact">Contact et signalement</h2>
      <p>
        Pour toute question légale, demande de retrait ou signalement :
        theo.salerno34@gmail.com.
      </p>
    </LegalLayout>
  );
}

export function LegalCgu() {
  return (
    <LegalLayout title="Conditions générales d’utilisation">
      <h2>1. Objet</h2>
      <p>
        Les présentes CGU encadrent l’accès et l’utilisation de Harf, plateforme
        d’apprentissage de l’arabe proposant des leçons, exercices, révisions
        espacées, progression et fonctionnalités de personnalisation.
      </p>
      <h2>2. Acceptation et compte</h2>
      <p>
        L’utilisation du service implique l’acceptation des présentes CGU.
        L’utilisateur fournit des informations exactes, protège ses identifiants
        et reste responsable de l’activité réalisée avec son compte. Le service
        est réservé aux personnes capables de contracter ; les mineurs doivent
        utiliser le service avec l’accord et sous la responsabilité de leur
        représentant légal.
      </p>
      <h2>3. Règles d’utilisation</h2>
      <p>
        Il est interdit de détourner le service, de tenter d’accéder aux comptes
        ou données d’autrui, de scraper massivement le site, de contourner les
        limites techniques, de publier des contenus illicites ou de porter
        atteinte aux droits de tiers.
      </p>
      <h2>4. Contenus et propriété</h2>
      <p>
        L’utilisateur conserve ses droits sur les données qu’il transmet. Il
        accorde à Harf la licence limitée nécessaire à l’hébergement,
        l’affichage et l’exécution du service. Les contenus et fonctionnalités
        Harf restent la propriété de l’éditeur ou de ses concédants.
      </p>
      <h2>5. Disponibilité et pédagogie</h2>
      <p>
        Harf est un outil pédagogique et ne garantit ni un niveau, ni une
        certification officielle, ni un résultat particulier. Le service peut
        évoluer, être interrompu pour maintenance ou être suspendu en cas
        d’usage abusif.
      </p>
      <h2>6. Suspension et suppression</h2>
      <p>
        L’utilisateur peut demander la suppression de son compte depuis son
        espace ou à l’adresse de contact. Harf peut suspendre un compte en cas
        de violation grave, fraude ou risque de sécurité, sous réserve des
        règles impératives applicables.
      </p>
      <h2>7. Droit applicable</h2>
      <p>
        Les présentes CGU sont soumises au droit français, sous réserve des
        dispositions impératives protectrices applicables au consommateur.
      </p>
    </LegalLayout>
  );
}

export function LegalCgv() {
  return (
    <LegalLayout title="Conditions générales de vente">
      <h2>1. Offres</h2>
      <p>
        Harf propose, sous réserve de disponibilité, les formules suivantes :
        abonnement mensuel à 7 € TTC, abonnement annuel à 70 € TTC et accès à
        vie à 100 € TTC.
      </p>
      <h2>2. Essai gratuit</h2>
      <p>
        Chaque nouveau compte bénéficie d’une période d’essai de 7 jours sans
        carte bancaire. À l’issue de l’essai, l’accès au site peut rester
        visible mais les fonctionnalités premium sont désactivées jusqu’à la
        souscription d’une offre ou l’attribution d’un accès gratuit validé.
      </p>
      <h2>3. Commande et paiement</h2>
      <p>
        La commande définitive intervient après affichage du récapitulatif,
        acceptation des présentes CGV et validation du paiement. Les
        transactions sont sécurisées et traitées par notre prestataire de
        paiement <strong>Stripe</strong>. Harf ne stocke pas vos données
        complètes de carte bancaire.
      </p>
      <h2>4. Abonnement, renouvellement et résiliation</h2>
      <p>
        L’abonnement mensuel ou annuel est renouvelé selon la périodicité
        affichée au moment de la commande, sauf résiliation avant le
        renouvellement. La résiliation est accessible depuis le compte. L’accès
        reste disponible jusqu’à la fin de la période payée.
      </p>
      <h2>5. Droit de rétractation</h2>
      <p>
        Le consommateur dispose en principe d’un délai de 14 jours. Pour un
        service numérique fourni immédiatement, la perte du droit de
        rétractation suppose une demande expresse et une reconnaissance de cette
        perte après le début de l’exécution au moment de la commande.
      </p>
      <h2>6. Remboursements et réclamations</h2>
      <p>
        Les demandes et réclamations doivent être adressées à
        theo.salerno34@gmail.com. En cas de litige non résolu à l'amiable, le
        consommateur peut saisir gratuitement le médiateur de la consommation
        compétent : le CM2C (Centre de la Médiation de la Consommation de
        Conciliateurs de Justice) accessible sur www.cm2c.net.
      </p>
      <h2>7. Accès gratuit par vidéos</h2>
      <p>
        Les accès attribués après vérification de vues sont des avantages
        promotionnels non monétaires. Ils sont soumis à la vérification des
        liens, à l’absence de fraude et aux conditions détaillées dans le
        formulaire concerné.
      </p>
    </LegalLayout>
  );
}

export function LegalPrivacy() {
  return (
    <LegalLayout title="Politique de confidentialité">
      <h2>1. Responsable du traitement</h2>
      <p>
        <strong>Responsable :</strong> Théo Salerno (Micro-entreprise).
        <br />
        <strong>Contact vie privée :</strong> theo.salerno34@gmail.com.
      </p>
      <h2>2. Données traitées</h2>
      <p>
        Harf peut traiter le nom, l’adresse email, les données de connexion, les
        progrès pédagogiques, les réponses aux exercices, les informations de
        facturation transmises par Stripe, les liens vidéo soumis et les
        journaux techniques nécessaires à la sécurité.
      </p>
      <h2>3. Finalités et bases</h2>
      <ul>
        <li>Créer et sécuriser le compte : exécution du contrat.</li>
        <li>
          Fournir la progression, les exercices et la personnalisation :
          exécution du contrat.
        </li>
        <li>
          Gérer les paiements et obligations comptables : contrat et obligation
          légale.
        </li>
        <li>Prévenir la fraude et sécuriser le service : intérêt légitime.</li>
      </ul>
      <h2>4. Destinataires et sous-traitants</h2>
      <p>
        Les données sont accessibles aux prestataires strictement nécessaires au
        fonctionnement de Harf : <strong>Replit</strong> pour l'hébergement de
        l'infrastructure technique, et <strong>Stripe</strong> pour le
        traitement sécurisé des paiements.
      </p>
      <h2>5. Durées</h2>
      <p>
        Les données du compte sont conservées pendant la relation, puis pendant
        les durées nécessaires aux obligations légales et à la défense des
        droits. Les demandes d’accès, suppression et export sont conservées le
        temps nécessaire à leur traitement et à la preuve de celui-ci.
      </p>
      <h2>6. Droits</h2>
      <p>
        Vous pouvez demander l’accès, la rectification, l’effacement, la
        limitation, la portabilité ou vous opposer à certains traitements en
        écrivant à theo.salerno34@gmail.com. Vous pouvez également saisir la
        CNIL après avoir contacté le responsable du traitement.
      </p>
      <h2>7. Sécurité et transferts</h2>
      <p>
        Harf met en œuvre des mesures raisonnables de sécurité, notamment le
        chiffrement des échanges et le contrôle des accès. Les éventuels
        transferts de données hors de l'Espace économique européen (vers nos
        prestataires américains comme Replit et Stripe) sont encadrés par des
        clauses contractuelles types ou des décisions d'adéquation.
      </p>
      <h2>8. Suppression du compte</h2>
      <p>
        La suppression peut être demandée depuis le compte ou par email à
        l'adresse de contact. Certaines données peuvent être conservées lorsque
        la loi l’impose, notamment pour la comptabilité ou la prévention de la
        fraude.
      </p>
    </LegalLayout>
  );
}

export function LegalCookies() {
  return (
    <LegalLayout title="Politique cookies">
      <h2>1. Cookies nécessaires</h2>
      <p>
        Harf utilise <strong>exclusivement</strong> des cookies et éléments de
        stockage local strictement nécessaires au fonctionnement du service
        (session d’authentification, mémorisation de votre progression
        pédagogique et préférences d’affichage locales). Ils ne servent pas à
        suivre votre activité sur d’autres sites.
      </p>
      <h2>2. Absence de cookies publicitaires ou de traçage</h2>
      <p>
        Harf respecte votre vie privée. Nous n'utilisons aucun outil de traçage
        publicitaire ni de solution de mesure d'audience intrusive (comme Google
        Analytics). Aucun consentement préalable n'est donc requis pour
        l'utilisation de notre plateforme, conformément aux recommandations de
        la CNIL concernant les cookies strictement fonctionnels.
      </p>
      <h2>3. Gérer vos choix</h2>
      <p>
        Vous pouvez à tout moment supprimer les données locales stockées par
        Harf en vidant le cache et les cookies directement depuis les paramètres
        de votre navigateur web. Veuillez noter que cela entraînera votre
        déconnexion du service.
      </p>
    </LegalLayout>
  );
}

export function LegalWithdrawal() {
  return (
    <LegalLayout title="Rétractation et réclamation">
      <h2>Exercer votre rétractation</h2>
      <p>
        Avant le démarrage immédiat d’un service numérique payant, demandez
        l’exercice de votre droit de rétractation dans les conditions prévues
        par les CGV. Envoyez votre demande à theo.salerno34@gmail.com en
        indiquant votre nom, email, offre et date de commande.
      </p>
      <h2>Formulaire type</h2>
      <p>
        « À l’attention de Théo Salerno (Harf), je vous notifie par la présente
        ma rétractation du contrat portant sur l’offre [offre], commandée le
        [date], au nom de [votre nom], avec l’adresse [votre email]. »
      </p>
      <h2>Réclamation</h2>
      <p>
        Pour toute réclamation, contactez en priorité le support à l'adresse
        theo.salerno34@gmail.com. En cas de litige persistant, vous pouvez
        recourir gratuitement au médiateur de la consommation (CM2C) tel que
        précisé dans nos Conditions Générales de Vente.
      </p>
    </LegalLayout>
  );
}
